
const Info = {
  TP: {
    // 支持热线
    Tel_HotLine: '400-6033-626'
  },
  NT: {
    // 支持热线
    Tel_HotLine: '400-1011-168'
  }
}

export default Info
